import { useSelector } from "react-redux";
import { ADMIN_EMAILS } from "../utils/constants";

export const useAdmin = () => {
  const { userInfo } = useSelector((state) => state.user);

  const isAdminUser = userInfo?.email && ADMIN_EMAILS.includes(userInfo.email);

  return {
    isAdminUser,
  };
};
